module.exports = __webpack_public_path__ + "static/key-riseofindustry-a8f621a9922aa9906b8706618f1b21e4.webp";